













































































import { Component, Vue } from 'vue-property-decorator';
import { ApiService, curApiService } from '@/services/ApiService';
import { ApiClient, curApiClient } from '../services/ApiClient';
import { curPref, Preferences } from '@/services/Preferences';
import { BaseStation, BssPage, NetworkUptimeReport } from '@/types';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import GeneratedReport from '@/components/reports/GeneratedReport.vue'; 

import moment from 'moment';

@Component({
  components: {
    Error,
    Loading,
    SectionHeader,
    GeneratedReport
  },
})

export default class Reports extends Vue {
  
  httpBusy:boolean = false;
  error:string = '';

  // model
  selectedDate:{start?:string, end?:string, shortcut?:string} = {};
  searchList:string = '';
  excludeList:string = '';
  minOutageSec:number = 60;

  currentReport:NetworkUptimeReport = {} as NetworkUptimeReport;
  
  // services
  apiService:ApiService = curApiService;
  apiClient:ApiClient = curApiClient;
  
  mounted() {
    // todo
  }

  async generateReport() {

    let now = new Date().getTime();

    let report = {
      startTs: parseInt(this.selectedDate.start as string, 10),
      endTs: parseInt(this.selectedDate.end as string, 10),
      searchList: this.searchList.replace(/\s+/g, ''),
      excludeList: this.excludeList.replace(/\s+/g, ''),
      minOutageSec: this.minOutageSec
    }

    // we correct with max endTs = now
    if(report.endTs > now)
      report.endTs = now - 60000;

    console.log(`Generating report ${JSON.stringify(report)}`);

    this.httpBusy = true;
    this.error = '';
    const reply = await this.apiClient.getUptimeReport(report);
    this.httpBusy = false;
    
    if(reply.errorMsg)
      return this.error = `Unable to generate report because ${reply.errorMsg}`;

    this.currentReport = reply.report!;

  }


  get dpCustomShortcuts():object[] {
    return  [
      { key: 'thisWeek', label: 'This week', value: 'isoWeek' },
      { key: 'lastWeek', label: 'Last week', value: '-isoWeek' },
      { key: 'last7Days', label: 'Last 7 days', value: 7 },
      { key: 'last30Days', label: 'Last 30 days', value: 30 },
      { key: 'thisMonth', label: 'This month', value: 'month' },
      { key: 'lastMonth', label: 'Last month', value: '-month' }
    ];
  }

  get dpMaxDate():string {
    return moment().format();
  }

  get canGenerateReport():boolean {
    return !this.httpBusy && this.selectedDate.start !== undefined && this.selectedDate.end !== undefined;
  }

  get canShowReport():boolean {
    return !this.httpBusy && this.currentReport.uptimePerc !== undefined;
  }

  reset() {
   this.selectedDate = {};
   this.searchList = '';
   this.excludeList = '';
   this.minOutageSec = 60;
   this.currentReport = {} as NetworkUptimeReport;
  }
}
